import { render, staticRenderFns } from "./DeleteShiftDialog.vue?vue&type=template&id=e694985a&"
import script from "./DeleteShiftDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DeleteShiftDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports